import { createRouteRef } from '@backstage/frontend-plugin-api';

export const exploreRouteRef = createRouteRef();
